import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAiBotHead: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"ai-bot-head, robot"} maskId="square-filled-radius-0-stroke-1-IconAiBotHead"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM9.125 13H10.375V9H9.125V13ZM13.625 9V13H14.875V9H13.625Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAiBotHead;
